import sectionReviewGridCss from '../css-snippets/section-review-grid';

const html = `
<style>${sectionReviewGridCss}</style>
<div
  class="review-grid-wrapper-unique-id"
  data-id="unique-id"
  data-attribute="review-grid-container"
  data-card-background-color="#f6f6f6"
  data-show-more-text="Show more"
  data-show-less-text="Show less"
  data-line-clamp="4"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="container">
    <div class="wrap-review-grid">
      <div class="header-review">
        <h2 data-attribute="title-review" class="title-review">Testimonials</h2>
      </div>
      <div data-attribute="body-review" class="body-review swiper">
        <div class="review-slider swiper-wrapper">
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
